goog.provide('el8.app.settings.idProofing');

goog.require('el8.app.settings.idProofingQuiz');
goog.require('el8.template.app.settings.dialog.idProofing');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.base');

el8.app.settings.idProofing = (function() {
    var that = new el8.uiwidget.FormDialog({
        title: 'Identity Verification via Experian',
        autoHeight: true,
        position: 'center',
        width: 500,
        contentFn: el8.template.app.settings.dialog.idProofing.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'dob',
                selector: ':input[name="dob"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'MM/DD/YYYY',
                maxLength: 10,
                validate: {
                    required: true,
                    validDate: true,
                    afterYear1900: true
                }
          },
          {
              name: 'phone',
              selector: ':input[name="phone"]',
              height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
              maxLength: 12,
              infoText: '555-555-5555',
              validate: {
                  required: true,
                  phone: true
              }
          },
          {
              name: 'address',
              selector: ':input[name="address"]',
              height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
              maxLength: 50,
              infoText: 'Address',
              validate: {
                  required: true
              }
          },
          {
              name: 'city',
              selector: ':input[name="city"]',
              height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
              maxLength: 50,
              infoText: 'City',
              validate: {
                  required: true
              }
          },
          {
              name: 'state',
              selector: ':input[name="state"]',
              height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
              maxLength: 2,
              infoText: 'XX',
              validate: {
                  required: true,
                  state: true
              }
          },
          {
              name: 'zip',
              selector: ':input[name="zip"]',
              height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
              maxLength: 12,
              infoText: 'Zip',
              validate: {
                  required: true,
                  zip: true
              }
          }
        ],
        validationOpts: el8.util.validate.standardOpts
    });

    var _postConsentAndFetchQuestions = function () {
      var form = that.getForm();
      if (!form.isValid()) { return false; }
      $.el8_ajax({
          type: 'POST',
          url: el8.service.urls.get('idpConsent'),
          data: JSON.stringify(form.getMapped(true, true)),
          success: function(data) {
            if (data) {
              // show quiz, passing question data
              el8.app.settings.idProofingQuiz.show(data);
              that.hide();
            } else {
              // Person not found, fail
                el8.uiwidget.nonAlarmingAlert('Your identity could not be verified. The Elation team will reach out to assist you. Please move forward for now.');
                // The current limitation of this flow is that only the current user can idproof themselves
                // Due to this limitation we are direcrtly using the global USER_ID
                el8React.dispatch.fetchUserIdProofStatus(el8Globals.PRACTICE_ID, el8Globals.USER_ID, true);
              
              that.hide();
            }
          }
      });
    };

    form.addButton(
        'agree', 'I Agree', function() {
            _postConsentAndFetchQuestions();
        }, true
    );
    form.addButton(
        'agree-and-print', 'I Agree & Print Copy of Consent', function() {
            window.open(el8.service.urls.get('printIDPConsent'));
            _postConsentAndFetchQuestions();
        }, false
    );
    form.addCancelButton(function() { that.hide(); }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    return that;
})();